/**
 * @generated SignedSource<<86c39794a80280069ed8c4fad0693211>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarkTxnsInternalInputObject = {
  destinationBankAccountId?: string | null | undefined;
  destinationName?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type useTxnBulkActions_MarkTxnsInternalMutation$variables = {
  input: MarkTxnsInternalInputObject;
};
export type useTxnBulkActions_MarkTxnsInternalMutation$data = {
  readonly markTxnsInternal: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type useTxnBulkActions_MarkTxnsInternalMutation = {
  response: useTxnBulkActions_MarkTxnsInternalMutation$data;
  variables: useTxnBulkActions_MarkTxnsInternalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTxnBulkActions_MarkTxnsInternalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkTxnsInternalMutationPayload",
        "kind": "LinkedField",
        "name": "markTxnsInternal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTxnBulkActions_MarkTxnsInternalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkTxnsInternalMutationPayload",
        "kind": "LinkedField",
        "name": "markTxnsInternal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac07290d01069f5a88a31e9bb770b383",
    "id": null,
    "metadata": {},
    "name": "useTxnBulkActions_MarkTxnsInternalMutation",
    "operationKind": "mutation",
    "text": "mutation useTxnBulkActions_MarkTxnsInternalMutation(\n  $input: MarkTxnsInternalInputObject!\n) {\n  markTxnsInternal(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f75d39683bc5b96fe1ca4c6345230c3";

export default node;
